import { MIN_SCROLL, CAPACITY_RESERVE, SCROLL_RESERVE } from '../paginator.constants';
import { Page } from '../types';

import { getMaxScroll, getSelectedIndex } from '.';

const getVisibleEdgePageIndexes = (pagesLength: number, scroll: number, paginatorCapacity: number) => {
    let firstVisiblePageIndex;
    let lastVisiblePageIndex;

    if (pagesLength <= paginatorCapacity) {
        firstVisiblePageIndex = 0;
        lastVisiblePageIndex = pagesLength - 1;
    } else if (scroll === MIN_SCROLL) {
        firstVisiblePageIndex = 0;
        lastVisiblePageIndex = paginatorCapacity - CAPACITY_RESERVE - 1;
    } else if (scroll === getMaxScroll(pagesLength, paginatorCapacity)) {
        firstVisiblePageIndex = pagesLength - (paginatorCapacity - CAPACITY_RESERVE);
        lastVisiblePageIndex = pagesLength - 1;
    } else {
        firstVisiblePageIndex = scroll;
        lastVisiblePageIndex = scroll + (paginatorCapacity - 2 * CAPACITY_RESERVE) - 1;
    }

    return { firstVisiblePageIndex, lastVisiblePageIndex };
};

export const getNextScroll = (
    pagesLength: number,
    nextPageIndex: number,
    prevScroll: number,
    paginatorCapacity: number
) => {
    const { firstVisiblePageIndex, lastVisiblePageIndex } = getVisibleEdgePageIndexes(
        pagesLength,
        prevScroll,
        paginatorCapacity
    );
    const capacitySufficient = pagesLength <= paginatorCapacity;

    const noNeedForScroll =
        (nextPageIndex >= firstVisiblePageIndex + SCROLL_RESERVE &&
            nextPageIndex <= lastVisiblePageIndex - SCROLL_RESERVE) ||
        capacitySufficient;
    const needMaxScroll = nextPageIndex >= pagesLength - CAPACITY_RESERVE - SCROLL_RESERVE;
    const needMinScroll = nextPageIndex <= CAPACITY_RESERVE + SCROLL_RESERVE;
    const needUpScroll = nextPageIndex < firstVisiblePageIndex + SCROLL_RESERVE;
    const needDownScroll = nextPageIndex > lastVisiblePageIndex - SCROLL_RESERVE;

    if (noNeedForScroll) {
        return prevScroll;
    } else if (needMaxScroll) {
        return getMaxScroll(pagesLength, paginatorCapacity);
    } else if (needMinScroll) {
        return MIN_SCROLL;
    } else if (needUpScroll) {
        const scrollDiff = firstVisiblePageIndex - nextPageIndex + SCROLL_RESERVE;

        return prevScroll - scrollDiff;
    } else if (needDownScroll) {
        const scrollDiff = nextPageIndex - lastVisiblePageIndex + SCROLL_RESERVE;
        const nextScroll = prevScroll + scrollDiff;

        if (nextScroll < CAPACITY_RESERVE + 1) {
            return CAPACITY_RESERVE + 1;
        }

        return nextScroll;
    }

    return prevScroll;
};

export const getInitialScroll = (pages: Page[], paginatorCapacity: number) => {
    const selectedIndex = getSelectedIndex(pages);
    const noNeedToScroll = selectedIndex <= paginatorCapacity - CAPACITY_RESERVE - 1;

    if (noNeedToScroll) {
        return MIN_SCROLL;
    }

    const desiredScroll = selectedIndex - CAPACITY_RESERVE - 1;
    const maxScroll = getMaxScroll(pages.length, paginatorCapacity);

    if (desiredScroll > maxScroll) {
        return maxScroll;
    }

    return desiredScroll;
};
